import { Alert, Autocomplete, TextField } from "@mui/material";
import { useGetUsersByClientAccountQuery } from "features/users/usersSlice";
import { approverNameFieldStyles } from "./ApproverNameFieldStyles";

const ApproverNameField = ({ value, onChange, clientAccountId }) => {
    const classes = approverNameFieldStyles();
    const { data: users } = useGetUsersByClientAccountQuery(clientAccountId, { skip: !clientAccountId });
    const options = users?.map(u => u.name) ?? [];

    return (
        <>
            {!value?.trim() && (
                <div className={classes.alertWrapper}>
                    <Alert severity="warning">Please enter the name of the person who approved this transition</Alert>
                </div>
            )}
            <Autocomplete
                freeSolo
                openOnFocus
                options={options}
                value={value ?? ''}
                onInputChange={(_, newValue) => onChange(newValue)}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Approver Name"
                        required
                        size="small"
                    />
                )}
            />
        </>
    );
};

export default ApproverNameField;
